import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/reports/@@individual.rpc`,
    services: {
        posttest_passed: {
            parameters: [
                {
                    name: 'member_id',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'session_id',
                    type: 'integer',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
